module.exports = __webpack_public_path__ + "static/media/SuperMIDIoBros.7068bde0.png";